// 非空間データテーブルとの結合スキル。
//
// 役割: 「データ」タブでアップロードされた位置情報なし CSV（データテーブル）を、空間レイヤーと
//       SQL JOIN して新レイヤーを作る手順をエージェントに与える。
// 関係: system-prompt.js が連結。テーブル本体（名前・列・サンプル）は useAgentSession が
//       formatDataTablesForPrompt でシステムプロンプト末尾に注入する。
export const DATA_JOIN_SKILL = `## スキル: データテーブルとレイヤーの結合

「アップロード済みデータテーブル（非空間）」（システムプロンプト末尾に列挙）は、位置情報を持たない
属性テーブル（例: 市区町村コード別の人口）。地図には載らないが、run_spatial_sql で空間レイヤーと
JOIN して新しいレイヤーを作れる。

### 手順
1. 対象の空間レイヤーを list_layers / describe_layer で確認し、結合キー列（例: code）を特定する。
2. データテーブルの列名・値は末尾の一覧（実在するもの）だけを使う。曖昧なら describe_layer で確認する。
3. run_spatial_sql に layer_name を付けて、レイヤーの geom を残したまま属性を JOIN する。
   結合キーは型不一致・先頭ゼロ落ち（市区町村コード等）を避けるため双方を VARCHAR にキャストする。

### 例
「市区町村ポリゴンレイヤー muni と アップした人口 CSV pop_table を code で結合」:
\`\`\`sql
SELECT p.*, d.population
FROM "muni" AS p
JOIN "pop_table" AS d
  ON CAST(p.code AS VARCHAR) = CAST(d.code AS VARCHAR)
\`\`\`
→ layer_name を付けて実行すると、geom を保持した結合レイヤーが地図に追加される。

### 注意
- 結果に geom 列（レイヤー側の \`p.geom\` または \`p.*\`）を必ず含める。含めないとレイヤー化できない。
- 同名列の衝突を避けるため、必要な属性は \`d.<列>\` で明示的に選ぶ。
- 結合前に件数や一致状況が不安なら、layer_name なしの SELECT でプレビューして確かめる。`
